import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useTranslation} from "react-i18next";
import Table from '../../../components/tables/Table';
import useCustomTable from '../../../components/tables/useCustomTable';
import { useGetDataVendorUsersQuery } from '../../../api/dataVendorUserApiSlice';
import Block from "../../../components/Block";

export default function DataVendorUsers(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { dataVendorKey: dataVendorId } = useParams();
  const {data: users, isSuccess} = useGetDataVendorUsersQuery(dataVendorId)

  const columns = [{
      Header: 'First name',
      accessor: 'firstName',
    },{
      Header: 'Last name',
      accessor: 'lastName',
    },{
      Header: 'Email',
      accessor: 'email'
    }, {
      Header: t('users.createdAt'),
      accessor: 'createdAt',
      format: 'date',
    }, {
      Header: t('users.lastConnection'),
      accessor: 'currentSignInAt',
      format: 'date'
    }
  ]

  const tableOptions = {
    sortable: true,
    filterable: true,
    paginate: false
  }

  const {
    tableProps,
  } = useCustomTable(tableOptions)

  const showUser = (user) => history.push(`/data_vendors/${dataVendorId}/users/${user.slug}`)

  if ( !isSuccess ) { return (<></>) }

  return (
    <Block>
      <Table data={users} columns={columns} onRowClick={showUser} {...tableOptions} {...tableProps}/>
    </Block>
  )
}




